export default "__VITE_ASSET__DbU0oTzp__"